<svg width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M0.5 1.5V14.5C0.5 16.1569 1.84315 17.5 3.5 17.5H17.5C19.1569 17.5 20.5 16.1569 20.5 14.5V6.5C20.5 4.84315 19.1569 3.5 17.5 3.5H2.00003C1.17162 3.5 0.500046 2.82845 0.50003 2.00003V2.00003C0.500013 1.17159 1.17159 0.5 2.00003 0.5H13.8445C15.3111 0.5 16.5 1.6889 16.5 3.15549V3.15549"
        stroke="var(--icon-color)" />
</svg>
